import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { fetchPageBySlug } from '../lib/api';

export default function NotFound() {
  const [pageData, setPageData] = useState(null);

  useEffect(() => {
    async function loadData() {
      const page = await fetchPageBySlug('404');
      setPageData(page);
    }
    loadData();
  }, []);

  useEffect(() => {
    document.title = pageData?.meta_title || '404 - Siden blev ikke fundet - Røjsmose Isolering ApS';
  }, [pageData]);

  return (
    <div className="py-24 sm:py-32 bg-white flex flex-col items-center justify-center text-center px-6">
      <div className="max-w-md">
        <p className="text-base font-semibold text-brand-orange">404</p>
        <h1 className="mt-4 text-3xl font-extrabold tracking-tight text-brand-navy sm:text-5xl">
          {pageData?.title || 'Siden blev ikke fundet'}
        </h1>
        <div
          className="mt-6 text-base leading-7 text-slate-600"
          dangerouslySetInnerHTML={{ __html: pageData?.content || '<p>Beklager, men den side du leder efter findes ikke.</p>' }}
        />
        <div className="mt-10">
          <Link
            to="/"
            className="rounded-full bg-brand-orange px-5 py-3 text-sm font-bold text-white shadow-sm transition-all hover:bg-brand-orange-hover"
          >
            Gå til forsiden
          </Link>
        </div>
      </div>
    </div>
  );
}
